import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css';
import '@trp-beacon-ui-kit/foundation/fonts/fonts.css';
import { reactBeaconControl } from '@trp-beacon-ui-kit/foundation/dist/react/beacon-control';

const projectName = "aam-message-center";
export const MessageComponentBeaconControl = reactBeaconControl(
  projectName
);

/*
const BeaconDropdown = ({
                          className,
                          id,
                          children,
                          label,
                          hint,
                          value,
                          handleChange,
                          disabled,
                          errorsMap
                        }) => {
  const DropdownRef = useRef();

  useEffect(() => {
    if(handleChange) {
      DropdownRef.current.addEventListener('beacon-event-input', handleChange)
    }

    return () => {
      if(handleChange) {
        DropdownRef.current.removeEventListener('beacon-event-input', handleChange)
      }
    }
  }, [])

  return (
    <MessageComponentBeaconDropdown id={id}
                             className={className}
                             ref={DropdownRef}
                             disabled={disabled}
                             hint={hint}
                             value={value}
                             required={true}
                             errorsMap={errorsMap}
                             label={label}>
      {children}
    </MessageComponentBeaconDropdown>
  );
};
*/